import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { Button } from "@volca/ui/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@volca/ui/components/ui/popover";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

export const PushPayExcludedLines = ({ warnings }: { warnings: string[] }) => {
  if (warnings.length === 0) return null;

  const label = `${warnings.length} ${warnings.length === 1 ? "line" : "lines"} not included`;

  return (
    <Popover>
      <PopoverTrigger
        render={
          <Button
            type="button"
            variant="ghost"
            size="xs"
            className="h-auto gap-1.5 px-0 py-1 text-subtle [&_svg]:size-4!"
          />
        }
      >
        <InfoIcon data-icon="inline-start" className="size-4" />
        {label}
      </PopoverTrigger>
      <PopoverContent align="end" sideOffset={8} className="w-md gap-0 p-0">
        <Stack align="start" gap={1} className="border-b border-line px-4 py-3">
          <Text className="font-medium">{label}</Text>
          <Text variant="caption" tone="muted">
            PushPay cannot push these lines. Review the reasons below.
          </Text>
        </Stack>
        <ul className="max-h-64 overflow-y-auto px-4 py-3">
          {warnings.map((warning, index) => (
            <li
              key={`${warning}-${index}`}
              className="border-b border-line py-2 last:border-b-0"
            >
              <Text variant="caption">{warning}</Text>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
};
